<template>
  <v-btn
    rounded
    depressed
    height="44"
    class="delete-doc-btn"
    @click="$emit('click')"
  >
    <omk-icon outline-variant class="mr-2">delete</omk-icon>
    Delete
  </v-btn>
</template>

<script>
  export default {
    name: 'DocumentDeleteCardButton',
  };
</script>

<style lang="scss" scoped>
  // Vuetify gives .v-btn its own margin, which pushed the button off the
  // card's content edge. mr-auto still wins on the right when it is set.
  .delete-doc-btn.v-btn.v-btn {
    margin: 0;
    padding: 0 24px;
    font-weight: 600;
    letter-spacing: normal;
    text-transform: none;
    background: var(--omk-colour-container-danger-resting, #fccfd7);
    color: var(--omk-colour-icon-danger-resting, #c0362c);
  }
  .delete-doc-btn.v-btn.v-btn:hover {
    background: var(--omk-colour-container-danger-press, #fa9eb0);
    color: var(--omk-colour-icon-danger-hover, #8f2820);
  }
  .delete-doc-btn omk-icon {
    --omk-icon-size: 20px;
  }
</style>
